/** browser_act action → the three tenses the transcript needs. */
export const BROWSER_ACT_VERBS: Record<
  string,
  { done: string; gerund: string; bare: string }
> = Object.assign(Object.create(null) as Record<string, never>, {
  click: { done: "Clicked", gerund: "Clicking", bare: "click" },
  dblclick: {
    done: "Double-clicked",
    gerund: "Double-clicking",
    bare: "double-click",
  },
  fill: { done: "Filled", gerund: "Filling", bare: "fill" },
  type: { done: "Typed into", gerund: "Typing into", bare: "type into" },
  select: { done: "Selected in", gerund: "Selecting in", bare: "select in" },
  check: { done: "Checked", gerund: "Checking", bare: "check" },
  uncheck: { done: "Unchecked", gerund: "Unchecking", bare: "uncheck" },
  hover: { done: "Hovered", gerund: "Hovering", bare: "hover" },
  press: {
    done: "Pressed a key on",
    gerund: "Pressing a key on",
    bare: "press a key on",
  },
  scroll: { done: "Scrolled", gerund: "Scrolling", bare: "scroll" },
  upload: {
    done: "Uploaded a file to",
    gerund: "Uploading a file to",
    bare: "upload a file to",
  },
});

/** browser_navigate history moves → their label, in the same three tenses. */
export const BROWSER_HISTORY_LABELS: Record<
  string,
  { done: string; gerund: string; bare: string }
> = Object.assign(Object.create(null) as Record<string, never>, {
  back: { done: "Went back", gerund: "Going back", bare: "go back" },
  forward: {
    done: "Went forward",
    gerund: "Going forward",
    bare: "go forward",
  },
  reload: {
    done: "Reloaded the page",
    gerund: "Reloading the page",
    bare: "reload the page",
  },
});
